import { Route, Routes } from 'react-router-dom';

import BackOfficePage from './pages/BackOfficePage';
import CampaignDashboardsPage from './pages/CampaignDashboardsPage';
import CampaignManagement from './pages/CampaignManagementPage';
import CampaignRegionNominationsPage from './pages/CampaignRegionNominationsPage';
import CampaignSettings from './pages/CampaignSettingsPage';
import CampaignsListPage from './pages/CampaignsListPage';
import CampaignSubsellerNominationsPage from './pages/CampaignSubsellerNominationsPage';
import ContactClientTaskPage from './pages/ContactClientTaskPage';
import ContactDetailPage from './pages/ContactDetailPage';
import ContactHistoryPage from './pages/ContactHistoryPage';
import ContactsPage from './pages/ContactsPage';
import DashboardPage from './pages/DashboardPage';
import DefaultPages from './pages/DefaultPages';
import DetailPage from './pages/DetailPage';
import LeadDetailPage from './pages/LeadDetailPage';
import ManualLeadPage from './pages/ManualLeadPage';
import MarketPlacePage from './pages/MarketPlacePage';
import MobileScanningPage from './pages/MobileScanningPage';
import NotFoundPage from './pages/NotFoundPage';
import PolicyOverviewPage from './pages/PolicyOverviewPage';
import PrintContactDetailPage from './pages/PrintContactDetailPage';
import PrintContactsListPage from './pages/PrintContactsListPage';
import PrintNeinPage from './pages/PrintNeinPage';
import ProducedProductionPage from './pages/ProducedProductionPage';
import ProductionControlDetailPage from './pages/ProductionControlDetailPage';
import ProductionControlPage from './pages/ProductionControlPage';
import RoboAdvisoryPage from './pages/RoboAdvisoryPage';
import SellerRequestPageNew from './pages/SellerRequestPageNew';
import SemaphorePage from './pages/SemaphorePage';
import SettingsPage from './pages/SettingsPage';
import SubordinateUsersPage from './pages/SubordinateUsersPage';
import TaskSearchPage from './pages/TaskSearchPage';
import TasksOverviewPage from './pages/TasksOverviewPage';
import TaskStatisticsPage from './pages/TaskStatisticsPage';
import UnlockedClientsPage from './pages/UnlockedClientsPage';

const Routers = () => (
	<Routes>
		<Route index element={<DefaultPages />} />
		<Route path="dashboard" element={<DashboardPage />} />
		<Route path="campaigns" element={<CampaignDashboardsPage />} />
		<Route path="campaign">
			<Route path="settings">
				<Route path="list" element={<CampaignsListPage type={'SETTINGS'} />} />
				<Route path=":campaignId" element={<CampaignSettings />} />
			</Route>
			<Route path="management">
				<Route path="list" element={<CampaignsListPage type={'MANAGEMENT'} />} />
				<Route path=":campaignId" element={<CampaignManagement />} />
			</Route>
			<Route path=":campaignId/nominations">
				<Route path="region" element={<CampaignRegionNominationsPage />} />
				<Route path="subseller" element={<CampaignSubsellerNominationsPage />} />
			</Route>
		</Route>
		<Route path="contacts" element={<ContactsPage />} />
		<Route path="contact-detail">
			<Route path=":contactId">
				<Route index element={<ContactDetailPage />} />
				<Route path="print" element={<PrintContactDetailPage />} />
			</Route>
		</Route>
		<Route path="print" element={<PrintContactsListPage />} />
		<Route path="market-place" element={<MarketPlacePage />} />
		<Route path="tasks" element={<TasksOverviewPage />} />
		<Route path="task">
			<Route path="search" element={<TaskSearchPage />} />
			<Route path="statistics" element={<TaskStatisticsPage />} />
			<Route path=":taskId">
				<Route path="detail" element={<DetailPage />} />
				<Route path="printNein" element={<PrintNeinPage />} />
			</Route>
		</Route>
		<Route path="seller-request" element={<SellerRequestPageNew />} />
		<Route path="contact-client" element={<ContactClientTaskPage />} />
		<Route path="manual-lead" element={<ManualLeadPage />} />
		<Route path="lead">
			<Route path=":leadId/detail" element={<LeadDetailPage />} />
		</Route>
		<Route path="mobile-scanning" element={<MobileScanningPage />} />
		<Route path="backoffice" element={<BackOfficePage />} />
		<Route path="production-control" element={<ProductionControlPage />} />
		<Route path="productionControl/:documentId/detail" element={<ProductionControlDetailPage />} />
		<Route path="produced-production" element={<ProducedProductionPage />} />
		<Route path="subordinates" element={<SubordinateUsersPage />} />
		<Route path="robo-advisory" element={<RoboAdvisoryPage />} />
		<Route path="policies" element={<PolicyOverviewPage />} />
		<Route path="semaphore" element={<SemaphorePage />} />
		<Route path="contact-history" element={<ContactHistoryPage />} />
		<Route path="unlocked-clients" element={<UnlockedClientsPage />} />
		<Route path="settings" element={<SettingsPage />} />
		<Route element={<NotFoundPage />} />
	</Routes>
);

export default Routers;
